import React, { useState, useEffect } from 'react'
import {
	Table,
	Input,
	Button,
	Dropdown,
	DropdownItem,
	DropdownToggle,
	DropdownMenu,
	Col,
	Row,
	Card,
	CardFooter,
	CardBody,
	Label,
	FormGroup,
	CardHeader,
	CardTitle
} from "reactstrap";
import moment from 'moment'
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
import Select from 'react-select';

import updateService from 'services/update.service'
import { useToolContext } from 'contexts/ToolContext'
import axios from 'axios'
import authHeader from 'services/auth-header'

// Special tool for DLL page only
const SPECIAL_TOOL = { matool: 'shared', name: 'Shared' };

function formatFileSize(bytes) {
	if (!bytes || bytes === 0) return '0 B';
	const units = ['B', 'KB', 'MB', 'GB'];
	const i = Math.floor(Math.log(bytes) / Math.log(1024));
	return (bytes / Math.pow(1024, i)).toFixed(i === 0 ? 0 : 1) + ' ' + units[i];
}

function DllOrders() {
	const { lstTool, selectedTool, selectedToolName, setSelectedTool, isLoading } = useToolContext();
	const [dll, setDll] = useState([])

	// Local dropdown state for showing special item
	const [dropdownOpen, setDropdownOpen] = useState(false);
	const toggle = () => setDropdownOpen(prevState => !prevState);

	// Local tool state (can be special or from context)
	const [localTool, setLocalTool] = useState('');
	const [localToolName, setLocalToolName] = useState('');

	const [typeFile, setTypeFile] = useState('Tải lên file')
	const [localPath, setLocalPath] = useState('')

	const [lstFolder, setLstFolder] = useState([])
	const [folderSelected, setFolderSelected] = useState('')

	const [lstFile, setLstFile] = useState([])
	const [fileSelected, setFileSelected] = useState('')

	const [selectedFile, setSelectedFile] = useState('')
	const [isDragging, setIsDragging] = useState(false)

	const handleFileSelect = (file) => {
		if (!file) return;
		setSelectedFile(file);
		if (!localPath) setLocalPath(`\\${file.name}`);
	};

	// Sync local tool with context when component mounts or context changes
	useEffect(() => {
		if (!isLoading && selectedTool) {
			setLocalTool(selectedTool);
			setLocalToolName(selectedToolName);
		}
	}, [isLoading, selectedTool, selectedToolName]);

	// Load DLLs when localTool changes
	useEffect(() => {
		if (localTool) {
			loadDll(localTool);
		}
	}, [localTool]);

	function handleToolChange(tool, toolName, isSpecial = false) {
		setLocalTool(tool);
		setLocalToolName(toolName);
		// Only save to global context if not a special item
		if (!isSpecial) {
			setSelectedTool(tool, toolName, true);
		}
	}

	const SERVER_LABELS = ['api.dhbtools.com', 'api2.dhbtools.com', 'api3.dhbtools.com'];

	const serverDataRef = React.useRef([null, null, null]);
	const baseDataRef = React.useRef([]);

	function loadDll(toolParam) {
		serverDataRef.current = [undefined, undefined, undefined];
		baseDataRef.current = [];

		const headers = { headers: authHeader() };
		const urls = [
			`${process.env.REACT_APP_MY_HOST}/v7/admin/dll/${toolParam}`,
			`${process.env.REACT_APP_FORWARD_HOST}/v7/admin/dll/${toolParam}`,
			`${process.env.REACT_APP_FORWARD_HOST3}/v7/admin/dll/${toolParam}`,
		];

		urls.forEach((url, i) => {
			axios.get(url, headers)
				.then(res => {
					if (res?.data?.data) {
						serverDataRef.current[i] = res.data.data;
					} else {
						serverDataRef.current[i] = [];
					}
				})
				.catch(() => {
					serverDataRef.current[i] = null;
				})
				.finally(() => {
					mergeAndSetDll();
				});
		});
	}

	function mergeAndSetDll() {
		const sData = serverDataRef.current;
		const baseData = sData[0] || sData[1] || sData[2] || [];
		baseDataRef.current = baseData;

		const serverMaps = sData.map(data => {
			if (!data) return {};
			const map = {};
			data.forEach(item => { map[item.id] = item; });
			return map;
		});

		const merged = baseData.map(record => {
			const servers = SERVER_LABELS.map((label, i) => {
				if (sData[i] === null) {
					return { label, exists: false, fileSize: null, online: false, loading: false };
				}
				if (sData[i] === undefined) {
					return { label, exists: false, fileSize: null, online: true, loading: true };
				}
				const serverRecord = serverMaps[i][record.id];
				return {
					label,
					exists: serverRecord ? (serverRecord.fileSize != null && serverRecord.fileSize > 0) : false,
					fileSize: serverRecord?.fileSize || null,
					online: true,
					loading: false
				};
			});
			return { ...record, servers };
		});

		setDll(merged);
	}

	function postDll(overrideFile, overrideType, overridePath) {
		let file = overrideFile || selectedFile;
		const _typeFile = overrideType || typeFile;
		if (_typeFile === "Chọn từ server") {
			file = folderSelected + "/" + fileSelected;
			setSelectedFile(file);
		}

		// Hiển thị Swal modal với 3 thanh progress
		let uploadCancelled = false;
		Swal.fire({
			title: 'Đang tải lên DLL...',
			width: '650px',
			html: `
      <style>
        .swal2-title { padding-bottom: 16px !important; }
        .swal2-actions { flex-direction: column !important; gap: 12px !important; }
        .swal2-loader { order: -1 !important; }
        .upload-server-card {
          background: #f8f9fa;
          border-radius: 10px;
          padding: 14px 18px;
          margin-bottom: 14px;
          border: 1px solid #e9ecef;
          text-align: left;
        }
        .upload-server-card.upload-success { border-color: #00b894; background: #f0fff4; }
        .upload-server-card.upload-error { border-color: #d63031; background: #fff5f5; }
        .upload-server-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 4px;
        }
        .upload-server-name {
          font-weight: 700;
          font-size: 15px;
          color: #2d3436;
        }
        .upload-server-host {
          font-size: 12px;
          color: #636e72;
          font-family: monospace;
        }
        .upload-server-info {
          display: flex;
          align-items: center;
          gap: 8px;
          margin-bottom: 10px;
          font-size: 12px;
          color: #636e72;
        }
        .upload-server-info .location-icon {
          color: #e74c3c;
        }
        .upload-dns-badge {
          background: #dfe6e9;
          padding: 2px 10px;
          border-radius: 4px;
          font-size: 11px;
          color: #636e72;
          margin-left: auto;
        }
        .upload-dns-badge.proxied {
          background: #ffeaa7;
          color: #d35400;
        }
        .upload-mb-info { font-size: 12px; color: #636e72; margin-bottom: 4px; display: flex; justify-content: space-between; align-items: center; }
        .upload-speed { color: #0984e3; font-weight: 600; }
        .upload-progress-wrapper {
          position: relative;
          width: 100%;
          height: 26px;
          background-color: #e9ecef;
          border-radius: 13px;
          overflow: hidden;
        }
        .upload-progress-bar {
          position: absolute;
          top: 0;
          left: 0;
          height: 100%;
          background: linear-gradient(90deg, #00b894, #00cec9);
          text-align: center;
          color: #fff;
          font-size: 11px;
          font-weight: 600;
          line-height: 26px;
          width: 0%;
          transition: width 0.4s ease;
          border-radius: 13px;
          white-space: nowrap;
          min-width: 45px;
        }
        .upload-status-msg { margin-top: 6px; font-size: 12px; font-weight: 600; display: none; }
        .upload-status-msg.success { color: #00b894; }
        .upload-status-msg.error { color: #d63031; }
        .upload-error-detail {
          margin-top: 6px; padding: 8px 10px; background: #fff0f0; border: 1px solid #ffcccc;
          border-radius: 6px; font-size: 11px; color: #636e72; font-family: monospace;
          word-break: break-all; max-height: 80px; overflow-y: auto; display: none;
        }
        .upload-retry-btn {
          margin-top: 6px; padding: 4px 14px; font-size: 11px; font-weight: 600;
          color: #fff; background: #0984e3; border: none; border-radius: 6px;
          cursor: pointer; display: none;
        }
        .upload-retry-btn:hover { background: #0652DD; }
        .upload-timer {
          display: flex;
          justify-content: center;
          align-items: center;
          gap: 12px;
          margin-top: 10px;
          font-size: 13px;
          color: #636e72;
        }
        .upload-timer .elapsed {
          font-weight: 600;
          color: #2d3436;
        }
        .upload-timer .timeout {
          color: #d63031;
          font-weight: 600;
        }
      </style>
      <div>
        <div id="card1" class="upload-server-card">
          <div class="upload-server-header">
            <span class="upload-server-name">Digital Ocean</span>
            <span class="upload-server-host">api.dhbtools.com</span>
          </div>
          <div class="upload-server-info">
            <i class="fas fa-map-marker-alt location-icon"></i>
            <span>Singapore</span>
            <span class="upload-dns-badge">DNS Only</span>
          </div>
          <div class="upload-mb-info" id="mbInfo1"><span class="upload-speed" id="speed1"></span><span>0.0/0.0 MB</span></div>
          <div class="upload-progress-wrapper">
            <div id="progressBar1" class="upload-progress-bar">0%</div>
          </div>
          <div id="status1" class="upload-status-msg"></div>
          <div id="detail1" class="upload-error-detail"></div>
          <button id="retry1" class="upload-retry-btn" onclick="window._retryUpload(0)"><i class="fas fa-redo"></i> Thử lại</button>
        </div>
        <div id="card2" class="upload-server-card">
          <div class="upload-server-header">
            <span class="upload-server-name">Viettel IDC</span>
            <span class="upload-server-host">api2.dhbtools.com</span>
          </div>
          <div class="upload-server-info">
            <i class="fas fa-map-marker-alt location-icon"></i>
            <span>Vietnam</span>
            <span class="upload-dns-badge proxied">Cloudflare Proxied</span>
          </div>
          <div class="upload-mb-info" id="mbInfo2"><span class="upload-speed" id="speed2"></span><span>0.0/0.0 MB</span></div>
          <div class="upload-progress-wrapper">
            <div id="progressBar2" class="upload-progress-bar">0%</div>
          </div>
          <div id="status2" class="upload-status-msg"></div>
          <div id="detail2" class="upload-error-detail"></div>
          <button id="retry2" class="upload-retry-btn" onclick="window._retryUpload(1)"><i class="fas fa-redo"></i> Thử lại</button>
        </div>
        <div id="card3" class="upload-server-card">
          <div class="upload-server-header">
            <span class="upload-server-name">Home Server NUC</span>
            <span class="upload-server-host">api3.dhbtools.com</span>
          </div>
          <div class="upload-server-info">
            <i class="fas fa-map-marker-alt location-icon"></i>
            <span>Vietnam</span>
            <span class="upload-dns-badge proxied">Cloudflare Proxied</span>
          </div>
          <div class="upload-mb-info" id="mbInfo3"><span class="upload-speed" id="speed3"></span><span>0.0/0.0 MB</span></div>
          <div class="upload-progress-wrapper">
            <div id="progressBar3" class="upload-progress-bar">0%</div>
          </div>
          <div id="status3" class="upload-status-msg"></div>
          <div id="detail3" class="upload-error-detail"></div>
          <button id="retry3" class="upload-retry-btn" onclick="window._retryUpload(2)"><i class="fas fa-redo"></i> Thử lại</button>
        </div>
      </div>
      <div class="upload-timer">
        <span><i class="fas fa-clock"></i> Đã tải lên: <span id="uploadElapsed" class="elapsed">00:00</span></span>
        <span>|</span>
        <span>Hết hạn: <span id="uploadTimeout" class="timeout">10:00</span></span>
      </div>
      `,
			allowOutsideClick: false,
			showConfirmButton: false,
			showCancelButton: true,
			cancelButtonText: '<i class="fas fa-times-circle"></i> Hủy tải lên',
			cancelButtonColor: '#dc3545',
			didOpen: () => {
				Swal.showLoading();
				const startTime = Date.now();
				const TIMEOUT_MS = 600000;
				window._uploadTimerInterval = setInterval(() => {
					const elapsed = Date.now() - startTime;
					const remaining = Math.max(0, TIMEOUT_MS - elapsed);
					const elapsedMin = Math.floor(elapsed / 60000);
					const elapsedSec = Math.floor((elapsed % 60000) / 1000);
					const remainMin = Math.floor(remaining / 60000);
					const remainSec = Math.floor((remaining % 60000) / 1000);
					const elEl = document.getElementById('uploadElapsed');
					const toEl = document.getElementById('uploadTimeout');
					if (elEl) elEl.textContent = `${String(elapsedMin).padStart(2,'0')}:${String(elapsedSec).padStart(2,'0')}`;
					if (toEl) {
						toEl.textContent = `${String(remainMin).padStart(2,'0')}:${String(remainSec).padStart(2,'0')}`;
						if (remaining < 60000) toEl.style.color = '#e17055';
						if (remaining < 30000) toEl.style.color = '#d63031';
					}
					if (remaining <= 0) clearInterval(window._uploadTimerInterval);
				}, 1000);
			}
		}).then((result) => {
			if (window._uploadTimerInterval) clearInterval(window._uploadTimerInterval);
			if (result.dismiss === Swal.DismissReason.cancel) {
				uploadCancelled = true;
				loadDll(localTool);
			}
		});

		const updateCardStatus = (cardIndex, status, message, errorDetail) => {
			const card = document.getElementById(`card${cardIndex}`);
			const statusEl = document.getElementById(`status${cardIndex}`);
			const detailEl = document.getElementById(`detail${cardIndex}`);
			const retryBtn = document.getElementById(`retry${cardIndex}`);
			const bar = document.getElementById(`progressBar${cardIndex}`);
			if (!card) return;
			if (status === 'success') {
				card.classList.add('upload-success'); card.classList.remove('upload-error');
				if (bar) { bar.style.width = '100%'; bar.textContent = '100%'; bar.style.background = 'linear-gradient(90deg, #00b894, #00cec9)'; }
				if (statusEl) { statusEl.innerHTML = message || '<i class="fas fa-check-circle"></i> Tải lên thành công'; statusEl.className = 'upload-status-msg success'; statusEl.style.display = 'block'; }
				if (detailEl) detailEl.style.display = 'none';
				if (retryBtn) retryBtn.style.display = 'none';
			} else if (status === 'error') {
				card.classList.add('upload-error'); card.classList.remove('upload-success');
				if (bar) { bar.style.background = '#d63031'; }
				if (statusEl) { statusEl.innerHTML = `<i class="fas fa-times-circle"></i> ${message || 'Tải lên thất bại'}`; statusEl.className = 'upload-status-msg error'; statusEl.style.display = 'block'; }
				if (detailEl && errorDetail) { detailEl.textContent = errorDetail; detailEl.style.display = 'block'; }
				if (retryBtn) retryBtn.style.display = 'inline-block';
			}
		};

		const speedTrackers = {};
		const makeProgressCallback = (barId, mbId, speedId) => (progressEvent) => {
			if (uploadCancelled) return;
			const now = Date.now();
			const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
			const loadedMB = (progressEvent.loaded / (1024 * 1024)).toFixed(1);
			const totalMB = (progressEvent.total / (1024 * 1024)).toFixed(1);
			const bar = Swal.getPopup()?.querySelector(`#${barId}`);
			const mbInfo = Swal.getPopup()?.querySelector(`#${mbId}`);
			const speedEl = Swal.getPopup()?.querySelector(`#${speedId}`);
			if (bar) { bar.style.width = percentCompleted + '%'; bar.textContent = `${percentCompleted}%`; }
			if (mbInfo) { const mbSpan = mbInfo.querySelector('span:last-child'); if (mbSpan) mbSpan.textContent = `${loadedMB}/${totalMB} MB`; }
			if (!speedTrackers[speedId]) speedTrackers[speedId] = { lastLoaded: 0, lastTime: now };
			const tracker = speedTrackers[speedId];
			const timeDiff = (now - tracker.lastTime) / 1000;
			if (timeDiff >= 0.5) {
				const bytesDiff = progressEvent.loaded - tracker.lastLoaded;
				const speedMBs = (bytesDiff / (1024 * 1024)) / timeDiff;
				if (speedEl) speedEl.innerHTML = `<i class="fas fa-bolt"></i> ${speedMBs.toFixed(1)} MB/s`;
				tracker.lastLoaded = progressEvent.loaded;
				tracker.lastTime = now;
			}
		};

		const serverMap = [
			{ index: 2, name: 'Viettel IDC' },
			{ index: 1, name: 'Digital Ocean' },
			{ index: 3, name: 'Home NUC' }
		];

		let completedCount = 0;
		let anySuccess = false;

		const handleServerResult = (i, response) => {
			if (uploadCancelled) return;
			const { index, name } = serverMap[i];
			console.log(`[DLL Upload] Server ${name} (${index}) response:`, response?.status, response?.data);
			if (response?.data?.success) {
				anySuccess = true;
				const dbCreated = response.data.dbCreated;
				const statusMsg = dbCreated
					? '<i class="fas fa-check-circle"></i> Tải lên thành công — <i class="fas fa-database"></i> Đã tạo bảng ghi'
					: '<i class="fas fa-check-circle"></i> Tải lên thành công';
				updateCardStatus(index, 'success', statusMsg);
			} else {
				const httpStatus = response?.status ? `HTTP ${response.status}` : 'No response';
				const serverMsg = response?.data?.message || JSON.stringify(response?.data) || 'Không có phản hồi từ server';
				const errorDetail = `[${httpStatus}] ${serverMsg}`;
				updateCardStatus(index, 'error', response?.data?.message || 'Tải lên thất bại', errorDetail);
			}
			checkAllDone();
		};

		const handleServerError = (i, error) => {
			if (uploadCancelled) return;
			const { index, name } = serverMap[i];
			console.error(`[DLL Upload] Server ${name} (${index}) ERROR:`, error?.message, error?.response?.status, error?.response?.data);
			const httpStatus = error?.response?.status ? `HTTP ${error.response.status}` : 'Network Error';
			const serverMsg = error?.response?.data?.message || JSON.stringify(error?.response?.data) || error?.message || 'Không thể kết nối';
			const errorDetail = `[${httpStatus}] ${serverMsg}`;
			updateCardStatus(index, 'error', error?.response?.data?.message || error?.message || 'Lỗi kết nối', errorDetail);
			checkAllDone();
		};

		const checkAllDone = () => {
			completedCount++;
			if (completedCount >= 3) {
				if (window._uploadTimerInterval) clearInterval(window._uploadTimerInterval);
				Swal.hideLoading();

				const titleEl = Swal.getTitle();
				if (titleEl) {
					titleEl.innerHTML = anySuccess
						? '<i class="fas fa-check-circle" style="color:#00b894"></i> Tải lên hoàn tất'
						: '<i class="fas fa-exclamation-triangle" style="color:#d63031"></i> Tải lên thất bại';
				}

				Swal.update({
					showConfirmButton: true,
					confirmButtonText: '<i class="fas fa-check"></i> Đóng',
					confirmButtonColor: anySuccess ? '#00b894' : '#d63031',
					showCancelButton: false
				});

				loadDll(localTool);
			}
		};

		const requests = updateService.postDll(
			localTool, _typeFile, overridePath || localPath, file,
			makeProgressCallback('progressBar2', 'mbInfo2', 'speed2'),
			makeProgressCallback('progressBar1', 'mbInfo1', 'speed1'),
			makeProgressCallback('progressBar3', 'mbInfo3', 'speed3')
		);

		if (requests) {
			requests.forEach((req, i) => {
				req.then((response) => {
					handleServerResult(i, response);
				}).catch((error) => {
					handleServerError(i, error);
				});
			});
		}

		// Retry: tải lại cho 1 server cụ thể
		const progressCallbacks = [
			makeProgressCallback('progressBar2', 'mbInfo2', 'speed2'),
			makeProgressCallback('progressBar1', 'mbInfo1', 'speed1'),
			makeProgressCallback('progressBar3', 'mbInfo3', 'speed3')
		];
		window._retryUpload = (serverIndex) => {
			const { index } = serverMap[serverIndex];
			const card = document.getElementById(`card${index}`);
			const bar = document.getElementById(`progressBar${index}`);
			const mbInfo = document.getElementById(`mbInfo${index}`);
			const statusEl = document.getElementById(`status${index}`);
			const retryBtn = document.getElementById(`retry${index}`);
			if (card) { card.classList.remove('upload-error', 'upload-success'); }
			if (bar) { bar.style.width = '0%'; bar.textContent = '0%'; }
			if (mbInfo) { const s = mbInfo.querySelector('span:last-child'); if (s) s.textContent = '0.0/0.0 MB'; }
			if (statusEl) { statusEl.style.display = 'none'; }
			if (retryBtn) { retryBtn.style.display = 'none'; }

			completedCount--;

			const urls = [
				`${process.env.REACT_APP_FORWARD_HOST}/v7/admin/dll/${localTool}`,
				`${process.env.REACT_APP_MY_HOST}/v7/admin/dll/${localTool}`,
				`${process.env.REACT_APP_FORWARD_HOST3}/v7/admin/dll/${localTool}`
			];
			const headers = {
				"Content-Type": "multipart/form-data"
			};

			const retryReq = updateService._uploadToServer(
				urls[serverIndex], file,
				{ type: typeFile, localPath },
				headers, progressCallbacks[serverIndex]
			);
			retryReq.then(res => handleServerResult(serverIndex, res))
					.catch(err => handleServerError(serverIndex, err));
		};
	}

	function showEditSwal(data) {
		const dirPath = `./update/${localTool}/dll/`;
		const fileName = data.url_v2 ? data.url_v2.split('/').pop().split('\\').pop() : '';
		window._swalSelectedFile = null;
		Swal.fire({
			title: `<i class="fas fa-edit" style="margin-right:8px;color:#3498db"></i> Chi tiết DLL<br><span style="font-size:14px;font-weight:400;color:#888;word-break:break-all">${data.url_v2 || ''}</span>`,
			width: '500px',
			html: `
				<div style="text-align:left;margin-top:12px">
					<label style="font-weight:600;font-size:14px;color:#525f7f;margin-bottom:4px;display:block">Đường dẫn người dùng</label>
					<input id="swal-path" class="swal2-input" value="${data.path || ''}" style="margin:0 0 16px 0;width:100%;box-sizing:border-box;font-size:14px;padding:6px 10px">
					<label style="font-weight:600;font-size:14px;color:#525f7f;margin-bottom:4px;display:block">Tên tệp trên server</label>
					<div style="display:flex;align-items:stretch;gap:8px;margin-bottom:16px">
						<input id="swal-url" class="swal2-input" value="${fileName}" style="margin:0;flex:1;box-sizing:border-box;font-size:14px;padding:6px 10px">
						<button type="button" id="swal-upload-btn" style="white-space:nowrap;padding:6px 18px;font-size:13px;font-weight:600;color:#fff;background:linear-gradient(135deg,#0984e3,#6c5ce7);border:none;border-radius:8px;cursor:pointer;display:flex;align-items:center;gap:6px;transition:all .2s ease;box-shadow:0 2px 8px rgba(9,132,227,0.3)">
							<i class="fas fa-upload"></i> Tải lên
						</button>
					</div>
					<input type="file" id="swal-file-input" style="display:none">
					<div id="swal-file-info" style="display:none;margin-bottom:12px;padding:8px 12px;background:#fef5e7;border:1px solid #f39c12;border-radius:8px;font-size:13px;color:#e67e22;font-weight:600">
						<i class="fas fa-file-upload" style="margin-right:5px"></i><span id="swal-file-name"></span>
					</div>
					<label style="font-weight:600;font-size:14px;color:#525f7f;margin-bottom:4px;display:block">Đường dẫn thư mục</label>
					<input class="swal2-input" value="${dirPath}" disabled style="margin:0;width:100%;box-sizing:border-box;font-size:14px;padding:6px 10px;background:#f0f0f0;color:#888">
				</div>
			`,
			showCancelButton: true,
			confirmButtonText: '<i class="fas fa-save"></i> Lưu',
			cancelButtonText: '<i class="fas fa-times"></i> Đóng',
			confirmButtonColor: '#00b894',
			cancelButtonColor: '#636e72',
			focusConfirm: false,
			didOpen: () => {
				const uploadBtn = document.getElementById('swal-upload-btn');
				const fileInput = document.getElementById('swal-file-input');
				uploadBtn.addEventListener('mouseover', () => { uploadBtn.style.transform = 'translateY(-1px)'; uploadBtn.style.boxShadow = '0 4px 12px rgba(9,132,227,0.4)'; });
				uploadBtn.addEventListener('mouseout', () => { uploadBtn.style.transform = ''; uploadBtn.style.boxShadow = '0 2px 8px rgba(9,132,227,0.3)'; });
				uploadBtn.addEventListener('click', () => fileInput.click());
				fileInput.addEventListener('change', (e) => {
					if (e.target.files[0]) {
						window._swalSelectedFile = e.target.files[0];
						document.getElementById('swal-file-name').textContent = 'Đã chọn tệp ' + e.target.files[0].name + '. Nhấn lưu để tải lên';
						document.getElementById('swal-file-info').style.display = 'block';
						const urlInput = document.getElementById('swal-url');
						if (!urlInput.value) urlInput.value = e.target.files[0].name;
					}
				});
			},
			preConfirm: () => {
				return {
					path: document.getElementById('swal-path').value,
					url_v2: document.getElementById('swal-url').value,
					file: window._swalSelectedFile
				};
			}
		}).then((result) => {
			if (result.isConfirmed) {
				const { path: newPath, url_v2: newUrl, file } = result.value;
				const fullUrl = `./update/${localTool}/dll/${newUrl}`;
				updateService.putDll(localTool, data.id, newPath, fullUrl).then((res) => {
					if (!res.data.success) {
						Swal.fire({ icon: 'error', title: res.data.message });
						return;
					}
					if (file) {
						const renamedFile = new File([file], newUrl, { type: file.type });
						postDll(renamedFile, 'Tải lên file', newPath);
					} else {
						Swal.fire({ icon: 'success', title: res.data.message, timer: 1200, showConfirmButton: false });
						loadDll(localTool);
					}
				}).catch(() => {
					Swal.fire({ icon: 'error', title: 'Lỗi kết nối' });
				});
			}
		});
	}

	function table() {
		return (
			<Table className="table-hover" style={{ marginTop: "10px", lineHeight: "15px" }}>
				<thead className="text-primary">
					<tr>
						<th className="table-device-mobile" style={{ whiteSpace: 'nowrap' }}>Cập nhập lúc</th>
						<th className="table-device-mobile" style={{ whiteSpace: 'nowrap' }}>Trạng thái</th>
						<th className="table-device-mobile" style={{ whiteSpace: 'nowrap' }}>Đường dẫn máy chủ</th>
						<th className="table-device-mobile" style={{ whiteSpace: 'nowrap' }}>Đường dẫn người dùng</th>
						<th className='text-center' style={{ whiteSpace: 'nowrap' }}>Xóa</th>
					</tr>
				</thead>
				<tbody>
					{dll.map((data, key) => (
						<tr key={key} onClick={() => showEditSwal(data)} style={{ cursor: 'pointer' }}>
							<td className="table-device-mobile" style={{ whiteSpace: 'nowrap' }}>{moment(data.createdAt).format('DD/MM/yyyy HH:mm')}</td>
							<td className="table-device-mobile" style={{ lineHeight: '2' }}>
							{data.servers ? (() => {
								const isLoading = data.servers.some(s => s.loading);
								const okCount = data.servers.filter(s => s.online && s.exists).length;
								const total = data.servers.length;
								const bg = isLoading ? '#b2bec3' : okCount === total ? '#00b894' : okCount > 0 ? '#fdcb6e' : '#d63031';
								const color = (okCount > 0 && okCount < total && !isLoading) ? '#2d3436' : '#fff';
								return (
									<span
										style={{
											display: 'inline-block', padding: '4px 16px', borderRadius: '12px',
											fontSize: '13px', fontWeight: 700, color, background: bg,
											cursor: 'pointer', ...(isLoading ? { opacity: 0.6 } : {})
										}}
										onClick={(e) => {
											e.stopPropagation();
											let html = '';
											data.servers.forEach(s => {
												let badge, detail;
												if (s.loading) {
													badge = 'background:#b2bec3;color:#fff';
													detail = '<i class="fas fa-spinner fa-spin"></i> Đang kiểm tra...';
												} else if (!s.online) {
													badge = 'background:#d63031;color:#fff';
													detail = '<i class="fas fa-times-circle"></i> Offline';
												} else if (s.exists) {
													badge = 'background:#00b894;color:#fff';
													detail = `<i class="fas fa-check-circle"></i> ${formatFileSize(s.fileSize)}`;
												} else {
													badge = 'background:#fdcb6e;color:#2d3436';
													detail = '<i class="fas fa-exclamation-triangle"></i> Không có tệp';
												}
												html += `<div style="display:flex;justify-content:space-between;align-items:center;padding:8px 12px;margin:4px 0;border-radius:8px;${badge}"><span style="font-weight:600;font-size:13px">${s.label}</span><span style="font-size:12px">${detail}</span></div>`;
											});
											Swal.fire({
												title: `Trạng thái tệp<br><span style="font-size:14px;font-weight:400;color:#888;word-break:break-all">${data.path}</span>`,
												html: `<div style="text-align:left">${html}</div>`,
												showConfirmButton: true,
												confirmButtonText: 'Đóng',
												confirmButtonColor: '#3498db',
												width: '420px'
											});
										}}
									>
										{isLoading ? <><i className="fas fa-spinner fa-spin" style={{fontSize:'11px', marginRight:'5px'}}/> Đang tải</> : <><i className="fas fa-server" style={{fontSize:'11px', marginRight:'5px'}}/>{okCount}/{total}</>}
									</span>
								);
							})() : '—'}
						</td>
							<td className="table-device-mobile" style={{ whiteSpace: 'nowrap' }}>{data.url_v2 ? data.url_v2.split('/').pop().split('\\').pop() : ''}</td>
							<td className="table-device-mobile" style={{ whiteSpace: 'nowrap' }}>{data.path}</td>
							<td className='text-center' style={{ whiteSpace: 'nowrap' }}>
								<Button
									style={{ marginLeft: "10px" }}
									type="button"
									className="btn btn-danger"
									onClick={(e) => {
										e.stopPropagation();
										Swal.fire({
											title: 'Xác nhận xóa ?',
											text: `Điều này sẽ xóa bản ghi ${data.path} phần mềm ${localToolName}`,
											icon: 'warning',
											showCancelButton: true,
											confirmButtonColor: '#3085d6',
											cancelButtonColor: '#d33',
											confirmButtonText: 'Có, xóa bản ghi!'
										}).then((result) => {
											if (result.isConfirmed) {
												updateService.deleteDll(data.tool, data.id, data.url_v2).then((results) => {
													const labels = ['api.dhbtools.com', 'api2.dhbtools.com', 'api3.dhbtools.com'];
													let html = '';
													let anyDbDeleted = false;
													results.forEach((r, i) => {
														const isOnline = r.status === 'fulfilled' && !(r.value instanceof Error);
														const d = isOnline ? r.value?.data : null;
														const fileOk = d?.fileDeleted;
														const dbOk = d?.dbDeleted;
														if (dbOk) anyDbDeleted = true;
														let badge, detail;
														if (!isOnline) { badge = 'background:#d63031;color:#fff'; detail = 'Offline'; }
														else if (dbOk && fileOk) { badge = 'background:#00b894;color:#fff'; detail = 'DB ✓ &nbsp; File ✓'; }
														else if (dbOk) { badge = 'background:#00b894;color:#fff'; detail = 'DB ✓'; }
														else if (fileOk) { badge = 'background:#00b894;color:#fff'; detail = 'File ✓'; }
														else { badge = 'background:#fdcb6e;color:#2d3436'; detail = 'Không tồn tại'; }
														html += `<div style="margin:4px 0"><span style="display:inline-block;padding:2px 10px;border-radius:12px;font-size:12px;font-weight:600;${badge}">${labels[i]} — ${detail}</span></div>`;
													});
													Swal.fire({
														icon: anyDbDeleted ? 'success' : 'warning',
														title: anyDbDeleted ? 'Xóa thành công' : 'Xóa file (DB không thay đổi)',
														html: html,
														showConfirmButton: true,
													});
													loadDll(localTool);
												});
											}
										});
									}}
								><i className="fas fa-trash" style={{ marginRight: '5px' }} /> Xóa</Button>
							</td>
						</tr>
					))}
				</tbody>
			</Table >
		)
	}


	return (
		<div className="content">
			<Row>
				<Col md="9">
					<Card style={{ backgroundColor: '#fff', borderRadius: '20px', border: 'none', boxShadow: '0 4px 20px rgba(0,0,0,0.08)', overflow: 'hidden' }}>
						<CardHeader style={{
							background: 'linear-gradient(135deg, #3498db 0%, #2980b9 100%)',
							padding: '18px 24px',
							border: 'none',
							display: 'flex',
							alignItems: 'center',
							gap: '12px'
						}}>
							<i className="fas fa-cogs" style={{ fontSize: '32px', color: '#fff', opacity: 0.9 }}></i>
							<div style={{ lineHeight: '1.3' }}>
								<Label style={{ fontSize: '18px', color: '#fff', fontWeight: '700', marginBottom: '0', display: 'block' }}>
									Danh sách DLL
								</Label>
								<span style={{ fontSize: '13px', color: 'rgba(255,255,255,0.7)' }}>
									{dll.length} bản ghi
								</span>
							</div>
						</CardHeader>
						<CardBody style={{ padding: '16px 24px' }}>
							{table()}
						</CardBody>
					</Card>
				</Col>

				<Col lg="3" md="4">
					<Card style={{ backgroundColor: '#fff', borderRadius: '20px', border: 'none', boxShadow: '0 4px 20px rgba(0,0,0,0.08)', overflow: 'hidden' }}>
						<CardHeader style={{
							background: 'linear-gradient(135deg, #198754 0%, #0f5132 100%)',
							padding: '18px 24px',
							border: 'none',
							display: 'flex',
							alignItems: 'center',
							gap: '12px'
						}}>
							<i className="fas fa-plus-circle" style={{ fontSize: '32px', color: '#fff', opacity: 0.9 }}></i>
							<div style={{ lineHeight: '1.3' }}>
								<Label style={{ fontSize: '18px', color: '#fff', fontWeight: '700', marginBottom: '0', display: 'block' }}>
									Thêm DLL
								</Label>
								<span style={{ fontSize: '13px', color: 'rgba(255,255,255,0.7)' }}>
									Upload hoặc chọn từ server
								</span>
							</div>
						</CardHeader>
						<CardBody style={{ padding: '16px 24px' }}>
							<FormGroup>
								<Label style={{ fontWeight: '600', fontSize: '14px', color: '#525f7f' }}>Nguồn dữ liệu</Label>
								<Select
									placeholder={typeFile}
									value={typeFile}
									onChange={(e) => {
										setTypeFile(e.value)
										if (e.value === "Chọn từ server") {
											updateService.getExplorerFiles("").then((result) => {
												const lst = result.data.data.map(item => ({ value: item, label: item }));
												setLstFolder(lst)
												setFolderSelected("./update/shared/dll")
												updateService.getExplorerFiles("./update/shared/dll").then((result) => {
													const lst = result.data.data.map(item => ({ value: item, label: item }));
													setLstFile(lst)
													setFileSelected("")
												})
											})
										}
									}}
									options={[
										{ value: 'Tải lên file', label: 'Tải lên file' },
										{ value: 'Chọn từ server', label: 'Chọn từ server' }
									]}
								/>

								{typeFile === 'Tải lên file'
									?
									<>
										<Label style={{ marginTop: "1rem", fontWeight: '600', fontSize: '14px', color: '#525f7f' }}>Đường dẫn người dùng</Label>
										<Input value={localPath} id="localPath" onChange={(e) => { setLocalPath(e.target.value) }} style={{ borderRadius: '20px' }} />
										<Label style={{ marginTop: "1rem", fontWeight: '600', fontSize: '14px', color: '#525f7f' }}>Tệp tin</Label>
										<div
											style={{
												border: `2px dashed ${isDragging ? '#0984e3' : selectedFile ? '#00b894' : '#cbd5e0'}`,
												borderRadius: '12px',
												padding: selectedFile ? '12px 16px' : '28px 16px',
												textAlign: 'center',
												background: isDragging ? 'rgba(9,132,227,0.05)' : selectedFile ? 'rgba(0,184,148,0.04)' : '#fafbfc',
												transition: 'all 0.2s ease',
												cursor: 'pointer'
											}}
											onDragOver={(e) => { e.preventDefault(); setIsDragging(true); }}
											onDragLeave={() => setIsDragging(false)}
											onDrop={(e) => { e.preventDefault(); setIsDragging(false); handleFileSelect(e.dataTransfer.files[0]); }}
											onClick={() => document.getElementById('file').click()}
										>
											{selectedFile ? (
												<div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
													<i className="fas fa-file" style={{ fontSize: '20px', color: '#00b894' }} />
													<div style={{ flex: 1, textAlign: 'left', overflow: 'hidden' }}>
														<div style={{ fontSize: '14px', fontWeight: 600, color: '#2d3436', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{selectedFile.name}</div>
														<div style={{ fontSize: '11px', color: '#636e72' }}>{(selectedFile.size / 1024).toFixed(1)} KB</div>
													</div>
													<Button color="info" size="sm" style={{ borderRadius: '20px', fontSize: '12px', whiteSpace: 'nowrap' }} onClick={(e) => { e.stopPropagation(); document.getElementById('file').click(); }}>
														<i className="fas fa-sync-alt" style={{ marginRight: '4px' }} /> Đổi tệp
													</Button>
												</div>
											) : (
												<>
													<i className={`fas ${isDragging ? 'fa-bullseye' : 'fa-cloud-upload-alt'}`} style={{ fontSize: '28px', color: isDragging ? '#0984e3' : '#a0aec0', marginBottom: '8px' }} />
													<div style={{ fontSize: '13px', color: isDragging ? '#0984e3' : '#636e72', fontWeight: isDragging ? 600 : 400 }}>
														{isDragging ? 'Thả tệp tại đây' : 'Kéo thả tệp vào đây hoặc'}
													</div>
													{!isDragging && (
														<Button color="info" size="sm" style={{ borderRadius: '20px', fontSize: '13px', marginTop: '8px' }} onClick={(e) => { e.stopPropagation(); document.getElementById('file').click(); }}>
															<i className="fas fa-folder-open" style={{ marginRight: '5px' }} /> Chọn tệp
														</Button>
													)}
												</>
											)}
											<Input type="file" id="file" style={{ display: 'none' }} onChange={(e) => { handleFileSelect(e.target.files[0]) }} />
										</div>
									</>
									:
									<>
										<div style={{ paddingTop: "15px" }}>
											<Label style={{ fontWeight: '600', fontSize: '14px', color: '#525f7f' }}>Thư mục</Label>
											<Select placeholder={folderSelected} value={folderSelected} onChange={(e) => {
												setFolderSelected(e.value)
												updateService.getExplorerFiles(e.value).then((result) => {
													const lst = result.data.data.map(item => ({ value: item, label: item }));
													setLstFile(lst)
													setFileSelected("")
												})
											}} options={lstFolder} />
										</div>
										<div style={{ paddingTop: "15px" }}>
											<Label style={{ fontWeight: '600', fontSize: '14px', color: '#525f7f' }}>Tập tin</Label>
											<Select placeholder={fileSelected} value={fileSelected} onChange={(e) => { setFileSelected(e.value) }} options={lstFile} />
										</div>
										<Label style={{ marginTop: "1rem", fontWeight: '600', fontSize: '14px', color: '#525f7f' }}>Local Path</Label>
										<Input value={localPath} id="localPath" onChange={(e) => { setLocalPath(e.target.value) }} style={{ borderRadius: '20px' }} />
									</>
								}
							</FormGroup>
						</CardBody>
						<CardFooter style={{ padding: '16px 24px', borderTop: '1px solid #f0f0f0' }}>
							<Button style={{ width: "100%", borderRadius: '20px', fontSize: '14px', padding: '8px 16px' }} color="success" onClick={() => postDll()}>
								<i className="fas fa-plus" style={{ marginRight: '5px' }} /> Thêm mới
							</Button>
						</CardFooter>
					</Card>
				</Col>
			</Row>
		</div>
	)
}

export default DllOrders;
